import React, { createContext, useContext, useState } from "react";
import { IBannerData, IGalleryBannerContext } from "../exports/interfaces";

const GalleryBannerContext = createContext<IGalleryBannerContext>({
  galleryBannerData: [],
  setGalleryBannerData: () => null,
});
export const useGalleryBannerContext = () => useContext(GalleryBannerContext);

export const GalleryBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [galleryBannerData, setGalleryBannerData] = useState<IBannerData[]>([]);

  return (
    <GalleryBannerContext.Provider
      value={{ galleryBannerData, setGalleryBannerData }}
    >
      {children}
    </GalleryBannerContext.Provider>
  );
};
